var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59186 1.22468L5.61443 5.20216C5.37035 5.44624 5.37035 5.84197 5.61443 6.08604C5.8585 6.33012 6.25423 6.33012 6.4983 6.08604L9.4088 3.17551V13.3333C9.4088 13.6785 9.68862 13.9583 10.0338 13.9583C10.379 13.9583 10.6588 13.6785 10.6588 13.3333V3.17551L13.5693 6.08604C13.8134 6.33012 14.2091 6.33012 14.4532 6.08604C14.6972 5.84197 14.6972 5.44624 14.4532 5.20216L10.4757 1.22468C10.2317 0.980607 9.83593 0.980607 9.59186 1.22468ZM3.94095 12.3534C3.85999 12.0178 3.52235 11.8114 3.18681 11.8924C2.85126 11.9733 2.64487 12.311 2.72583 12.6465C3.77475 16.9942 7.07263 19.0523 10.3129 18.955C13.5373 18.8582 16.646 16.621 17.2838 12.5978C17.3379 12.2569 17.1053 11.9367 16.7644 11.8827C16.4235 11.8286 16.1033 12.0612 16.0493 12.4021C15.5107 15.7993 12.9332 17.6257 10.2753 17.7056C7.63327 17.7849 4.85279 16.1328 3.94095 12.3534Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.56319132268c359a74489ad3ae216c25.svg";
export { ForwardRef as ReactComponent };